/**
 * The shape of a dictionary, and the rules for reading one (feature 0050).
 *
 * A dictionary is a flat map from a stable key to either one sentence or, when the sentence counts things,
 * a set of plural forms. Flat and not nested: the key's prefix IS the category the seller sees in the text
 * editor (`cart.` → Panier, `checkout.` → Commande), so nesting would only add a second way to say the same
 * thing and a second way to get it wrong.
 */
/** True when the value is a set of plural forms rather than a single sentence. */
export function isPlural(phrase) {
    return (typeof phrase === 'object' &&
        phrase !== null &&
        typeof phrase.other === 'string');
}
//# sourceMappingURL=dictionary.js.map